// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.loader--circle[data-v-5c36cd16] {\n    overflow: hidden;\n    width: 100px;\n    height: 100px;\n    background-color: red;\n    border-radius: 50%;\n    position: relative;\n}\n.loader--circle[data-v-5c36cd16]::before {\n    content: '';\n    display: block;\n    position: absolute;\n    inset: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
